/* @ngInject */
function approvalsService (ConnectorWebService, CONSTANTS, Utils, $translate) {
  const service = {
    getApprovalTimesOptions,
    getApproval,
    createApproval,
    updateApprovalStatus,
    updateApprovalAssetStatus,
    deleteApproval,
    updateApproval,
    getMyApprovals,
    getMyApprovalsOverdueCount,
    getApproverTooltipContentWithStatus,
    getAllInternalApprovalForTask,
    getAssignableUsers
  }
  return service

  function getApprovalTimesOptions (selectedOption) {
    const getTimes = (start = 0, end = 24) => {
      // convert start and end times to hours
      const radix = 10
      const startTime = parseInt(start, radix)
      const endTime = parseInt(end, radix)

      // create array of times with a 1-hour interval
      const times = Array.from({ length: endTime - startTime }, (_, index) =>
        ((index + startTime) + ':00').padStart(5, '0')
      )

      const dateTimes = times.map(time => {
        return {
          label: time,
          value: time
        }
      })

      return dateTimes
    }

    const options = getTimes()

    if (!selectedOption) {
      return options
    }

    return options.map(option => ({
      label: option.label,
      value: option.value,
      active: option.value === selectedOption
    }))
  }

  function getApproval (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_APPROVALS_V2_ID, [id])
    return ConnectorWebService.get(url)
  }

  function createApproval (payload) {
    return ConnectorWebService.post(CONSTANTS.URL_APPROVALS_V2, payload)
  }

  function updateApprovalStatus (approvalId, status, message) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_APPROVALS_V2_ID_STATUS, [approvalId])
    const payload = { status }

    if (message) {
      payload.message = message
    }

    return ConnectorWebService.put(url, payload)
  }

  function updateApprovalAssetStatus (approvalId, assetId, status, message) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_APPROVALS_V2_ID_ASSET_STATUS, [approvalId, assetId])
    const payload = { status }

    if (message) {
      payload.message = message
    }

    return ConnectorWebService.put(url, payload)
  }

  function updateApproval (approvalId, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_APPROVALS_V2_ID, [approvalId])

    return ConnectorWebService.put(url, payload)
  }

  function deleteApproval (approvalId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_APPROVALS_V2_ID, [approvalId])

    return ConnectorWebService.fnDelete(url)
  }

  function getMyApprovals (params) {
    let url = CONSTANTS.URL_APPROVALS_ME

    if (params.$top || params.$skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, params.$top, params.$skip)
    }

    if (params.$sort || params.$order) {
      url = Utils.fnAddQueryToUrl(url, { $sort: params.$sort, $order: params.$order })
    }

    if (params.filters) {
      Object.keys(params.filters).forEach(key => {
        url = Utils.fnAddQueryToUrl(url, { [key]: params.filters[key] })
      })
    }

    return ConnectorWebService.get(url)
  }

  function getAllInternalApprovalForTask (taskId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASK_V2_ID_APPROVALS_HISTORY, [taskId])

    return ConnectorWebService.get(url)
  }

  function getMyApprovalsOverdueCount () {
    return ConnectorWebService.get(CONSTANTS.URL_APPROVALS_ME_OVERDUE_COUNT)
  }

  function getApproverTooltipContentWithStatus (approver) {
    const status = $translate.instant(`internalApprovalStatuses.${approver.approvalStatus}`)
    return `${approver.name} - ${status}`
  }

  function getAssignableUsers (params = {}, pagination = {}) {
    const { $top = 10, $skip } = pagination
    const { role, search, $sort, ignoreUserIds, taskId } = params

    let url = Utils.fnAddQueryToUrl(CONSTANTS.URL_APPROVALS_ASSIGNABLE_USERS, {
      $top,
      $skip,
      $sort
    })

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    if (ignoreUserIds?.length) {
      url = Utils.addQueryStringFromArray(url, 'ignoreUserIds', ignoreUserIds)
    }

    if (role?.length) {
      url = Utils.addQueryStringFromArray(url, 'role', role)
    }

    if (taskId) {
      url = Utils.fnAddQueryToUrl(url, { taskId })
    }

    return ConnectorWebService.get(url)
  }
}

export { approvalsService }
